export const OS = 'web';
export const Platform = {
  OS,
};

export default {
  OS,
  Platform,
  StatusBar: {},
};
